
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saas-na-zamowienie",
      function () {
        return require("private-next-pages/saas-na-zamowienie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saas-na-zamowienie"])
      });
    }
  